const config = {
  bucket: {
    slug: process.env.VUE_APP_COSMIC_BUCKET || 'quickstart',
    read_key: process.env.VUE_APP_COSMIC_READ_KEY,
    write_key: process.env.VUE_APP_COSMIC_WRITE_KEY
  },
  object_type: document
    .getElementById('quickstart-widget')
    .getAttribute('cosmic-objects')
}

export default config
